import { ISapSyncLog } from 'interfaces';
import { BaseService } from './BaseService';

class SapSyncLogService extends BaseService<ISapSyncLog> {
  constructor() {
    super('sap-logging');
  }
  canBulkDelete = true;
}

export const sapSyncLogService = new SapSyncLogService();
